import React from 'react'
import { rem } from 'polished'
import DatePickerWithType from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Input } from '../Input'
import { IDatepickerProps } from './Datepicker.types'
import css from './Datepicker.module.scss'

export const MAX_DATE_RANGE = 21

const CalendarIcon = ({ isDark }: { isDark?: boolean }) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1667 10H8V14.1667H12.1667V10ZM11.3333 0.833333V2.5H4.66667V0.833333H3V2.5H2.16667C1.24583 2.5 0.508333 3.24583 0.508333 4.16667L0.5 15.8333C0.5 16.7542 1.24583 17.5 2.16667 17.5H13.8333C14.7542 17.5 15.5 16.7542 15.5 15.8333V4.16667C15.5 3.24583 14.7542 2.5 13.8333 2.5H13V0.833333H11.3333ZM13.8333 15.8333H2.16667V6.66667H13.8333V15.8333Z"
      fill={isDark ? '#ffffff' : '#525E72'}
    />
  </svg>
)

export const Datepicker = <IsRange extends boolean | undefined>({
  minDate,
  maxDate,
  startDate: initialStartDate,
  endDate: initialEndDate,
  inputProps,
  isDark,
  selectsRange,
  excludeDateIntervals,
  onChange,
  ...passingProps
}: IDatepickerProps<IsRange>) => {
  const [startDate, setStartDate] =
    React.useState<Date | undefined | null>(null)
  const [endDate, setEndDate] = React.useState<Date | undefined | null>(null)

  React.useEffect(() => {
    setStartDate(initialStartDate)
    setEndDate(initialEndDate)
  }, [initialStartDate, initialEndDate])

  const _onChange = (
    val: IsRange extends false | undefined
      ? Date | null
      : [Date | null, Date | null],
    e: React.SyntheticEvent<any> | undefined
  ) => {
    if (selectsRange) {
      setEndDate((val as [Date | null, Date | null])[1])
      setStartDate((val as [Date | null, Date | null])[0])
    } else setStartDate(val as Date)

    onChange(val, e)
  }

  return (
    <div>
      <div className={`${css.calendarStyle} ${isDark ? css.calendarDark : ''}`}>
        {/** @ts-ignore */}
        <DatePickerWithType
          excludeDateIntervals={excludeDateIntervals}
          onChange={_onChange}
          startDate={startDate}
          endDate={endDate}
          selected={startDate}
          selectsRange={selectsRange}
          minDate={minDate}
          customInput={
            <Input
              type="date"
              style={{ cursor: 'text', height: rem(42) }}
              iconRight={<CalendarIcon isDark={isDark} />}
              isDark={isDark}
              {...inputProps}
            />
          }
          maxDate={maxDate}
          shouldCloseOnSelect={false}
          showDisabledMonthNavigation
          {...passingProps}
        />
      </div>
    </div>
  )
}
